import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import {
  CreateRoleOnboardingCourse,
  MyRoleOnboarding,
  PendingRoleOnboarding,
  RoleOnboardingAcknowledgement,
  RoleOnboardingCourse
} from '../components/role-onboarding/role-onboarding';

@Injectable({
  providedIn: 'root'
})
export class RoleOnboardingService {
  private apiUrl = environment.apiUrl + 'RoleOnboarding/';

  constructor(private http: HttpClient, private authService: AuthService) { }

  private authHeaders(): HttpHeaders {
    const token = this.authService.getAuthToken();
    return new HttpHeaders({ Authorization: 'Bearer ' + token });
  }

  getAll(): Observable<RoleOnboardingCourse[]> {
    return this.http.get<RoleOnboardingCourse[]>(this.apiUrl + 'getAll', { headers: this.authHeaders() });
  }

  getById(id: number): Observable<RoleOnboardingCourse> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<RoleOnboardingCourse>(this.apiUrl + 'getById', { headers: this.authHeaders(), params });
  }

  getAcknowledgements(id: number): Observable<RoleOnboardingAcknowledgement[]> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<RoleOnboardingAcknowledgement[]>(this.apiUrl + 'acknowledgements', { headers: this.authHeaders(), params });
  }

  create(course: CreateRoleOnboardingCourse): Observable<boolean> {
    return this.http.post<boolean>(this.apiUrl + 'create', course, { headers: this.authHeaders() });
  }

  update(course: RoleOnboardingCourse): Observable<boolean> {
    const body = {
      id: course.id,
      role: course.role,
      title: course.title,
      videoUrl: course.videoUrl || null,
      videoFileId: course.videoFileId || null,
      description: course.description,
      isActive: course.isActive,
      isMandatory: course.isMandatory,
      displayOrder: Math.max(1, Math.floor(Number(course.displayOrder)) || 1)
    };
    return this.http.post<boolean>(this.apiUrl + 'update', body, { headers: this.authHeaders() });
  }

  getPending(): Observable<PendingRoleOnboarding[]> {
    return this.http.get<PendingRoleOnboarding[]>(this.apiUrl + 'pending', { headers: this.authHeaders() });
  }

  getMine(): Observable<MyRoleOnboarding[]> {
    return this.http.get<MyRoleOnboarding[]>(this.apiUrl + 'mine', { headers: this.authHeaders() });
  }

  acknowledge(courseId: number): Observable<boolean> {
    return this.http.post<boolean>(this.apiUrl + 'acknowledge', { courseId }, { headers: this.authHeaders() });
  }
}
